import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { FIELD_TYPES, SENIORITIES } from '../../../utils/utils';
import { Fields } from '../../Fields';
import JHApi from "../../../utils/JHApi"

export default function JobsFoundDialog(props) {
    const isAdmin = props.isAdmin
    const userId = props.userId
    const extraInfoDialog = props.extraInfoDialog || {}
    const isOpen = (extraInfoDialog.type === 'signed')
    const initialFoundJobData = {salaryCurrency:'ILS', salaryFrequency:'MONTH', type:'After Service'}

    const [error, setError] = useState();
    const [disabled, setDisabled] = useState();
    const [newJobData, setNewJobData] = useState(initialFoundJobData);

    const handleChangeTitle = (titleGroup, titleCategories) => {
        if (getValueFoundJob('title', '')){
            setNewJobData({...newJobData, titleGroup, titleCategories})
        } else {
            setNewJobData({...newJobData, title:titleGroup, titleGroup, titleCategories})
        }
    }

    const handleChangeField = (name, date) => {
        setNewJobData({...newJobData,[name]: date})
    };
    
    const handleChangeFieldFoundJob = e => {
        setNewJobData({...newJobData,[e.target.name]: e.target.value})
    };

    const getValueFoundJob = (name, defaultValue) => {
        if (newJobData[name] !== undefined){
            return newJobData[name]
        } else {
            return defaultValue
        }
    }

    const getDateValue = (name) => {
        if (newJobData[name]){
            return newJobData[name].toString()
        } else {
            return ''
        }
    }

    const handleClose = () => {
        setNewJobData(initialFoundJobData)
        props.onClose()
    }

    const handleAddTalentJob = e => {
        e.preventDefault();

        let paramsToPass = {newJobData}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setDisabled(true)

        JHApi.addTalentJob(paramsToPass,(response)=>{
            setError()
            setDisabled(false)
            handleClose()
            props.handleSave()
        }, (error) => {
            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
            setDisabled(false)
        })
    }

    const fieldsTalentJob = [
        //{name:'type', label:'Type', defaultValue: '', type:FIELD_TYPES.SELECT, options:jobType, required:true},
        {name:'company', label:'Company', defaultValue: '', type:FIELD_TYPES.TEXT},
        {name:'titleGroup', label:'Professional Title', type:FIELD_TYPES.TITLE, handleChangeTitle, required: true},
        {name:'title', label:'Professional Title (Free Text)', defaultValue: '', hide: (!getValueFoundJob('titleGroup', '') && !getValueFoundJob('title', '')) , type:FIELD_TYPES.TEXT, required: true},
        {name:'seniority', label:'Seniority', defaultValue: '', type:FIELD_TYPES.SELECT, options:SENIORITIES},
        {name:'salary', label:'Salary', curField:'salaryCurrency', freqField:'salaryFrequency', defaultValue: 0, type:FIELD_TYPES.CASH},
        {name:'dateStart', label:'Start', defaultValue: '', type:FIELD_TYPES.DATE2},
    ]

    return (
        <Dialog onClose={handleClose} open={isOpen} fullWidth maxWidth='md'>
            <form onSubmit={handleAddTalentJob}>
                <DialogContent dividers>
                    {(error)&&<Typography color="error">{error}</Typography>}
                    <Fields fields={fieldsTalentJob} getValue={getValueFoundJob} handleChange={handleChangeFieldFoundJob} getDateValue={getDateValue} handleChangeField={handleChangeField}/>
                </DialogContent>
                <DialogActions>
                    <Button disabled={disabled} onClick={handleClose} color="primary" size="small">
                        Cancel
                    </Button>
                    <Button
                        disabled={disabled}
                        type="submit"
                        variant="outlined"
                        color="primary"
                        size="small"
                    >
                        Save
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}